module.exports = __webpack_public_path__ + "assets/img/help_image01-3@2x.cee4df13.png";